import { useTranslation } from 'react-i18next';

const TextoNoticia = ({ noticia, ruta }) => {

    const { t } = useTranslation();

    var imagen = "/images/web/bedloop-nofoto.png";

    if (noticia.imagen) {
        imagen = ruta + "/blog/" + noticia.id + "/" + noticia.imagen;
    }

    const results = [];
    return (
        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <div className="imatge-banner" title={t("Blog")} style={{ backgroundImage: "url('" + imagen + "')", backgroundRepeat: 'no-repeat', backgroundPosition: 'center', backgroundSize: "cover" }} >
                    </div>
                    <h1 className="mt-5 mb-5 noticia-individual">{noticia.eltitulo}</h1>
                    <div className="mb-4 noticia-individual meta gris">
                        <i className="fa fa-calendar"></i> <a className="gris" href="#">
                            {new Date(noticia.fecha_publica).toLocaleDateString('es-ES', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric'
                            }).replace(/\//g, '-')}
                        </a>
                    </div>
                    <p className="mb-4 noticia-individual-descripcio-curta fw-bolder" dangerouslySetInnerHTML={{ __html: noticia.ladesccorta }}></p>
                    <p className="mb-5 noticia-individual-descripcio-llarga" dangerouslySetInnerHTML={{ __html: noticia.ladesclarga }}></p>
                </div>
            </div>
        </div>
    );
}

export default TextoNoticia;
